import { indexDocument } from './document'
import { LIMITS } from './protocol'

const TEXT_LIMIT = 80

function summarizeNode(doc) {
  const summary = { id: doc.id, block: doc.block }

  if (doc.name && doc.name !== doc.block) {
    summary.name = doc.name
  }

  if (doc.text) {
    summary.text = doc.text.length > TEXT_LIMIT ? `${doc.text.slice(0, TEXT_LIMIT)}…` : doc.text
  }

  const tag = doc.props?.tagName
  if (typeof tag === 'string') {
    summary.tag = tag
  }

  if (doc.classes) {
    summary.classes = doc.classes
  }

  if (doc.hidden) {
    summary.hidden = true
  }

  return summary
}

export function buildOutline(document, { root, depth = LIMITS.outlineDepth, maxNodes = LIMITS.outlineMaxNodes } = {}) {
  const byId = indexDocument(document)
  const rootId = root || document.root
  const rootDoc = byId.get(rootId)

  if (!rootDoc) {
    return { root: rootId, truncated: false, count: 0, node: null }
  }

  const summaries = new Map()
  const queue = [{ id: rootId, level: 0 }]
  const start = summarizeNode(rootDoc)
  summaries.set(rootId, start)

  let count = 1
  let truncated = false

  while (queue.length) {
    const { id, level } = queue.shift()
    const doc = byId.get(id)
    const summary = summaries.get(id)
    const entries = [
      ...Object.keys(doc.linked).sort().map(name => ({ name, childId: doc.linked[name] })),
      ...doc.children.map(childId => ({ childId })),
    ]

    if (level >= depth) {
      if (entries.length) {
        summary.more = entries.length
        truncated = true
      }
      continue
    }

    let omitted = 0
    for (const { name, childId } of entries) {
      const child = byId.get(childId)
      if (!child) {
        continue
      }

      if (count >= maxNodes) {
        omitted++
        continue
      }

      const childSummary = summarizeNode(child)
      summaries.set(childId, childSummary)
      count++

      if (name) {
        summary.linked = summary.linked || {}
        summary.linked[name] = childSummary
      } else {
        summary.children = summary.children || []
        summary.children.push(childSummary)
      }

      queue.push({ id: childId, level: level + 1 })
    }

    if (omitted) {
      summary.more = omitted
      truncated = true
    }
  }

  return { root: rootId, truncated, count, node: start }
}
